export const SIDEBAR_WIDTH = 228;
export const SIDEBAR_COLLAPSED_WIDTH = 80;
